import { FunctionComponent } from 'react';
import classnames from 'classnames';

import { SIZES } from '../constants';

import styles from './TextInputContainer.scss';

type TextInputContainerProps = {
    paddingTop?: typeof SIZES.none | typeof SIZES.animatedPlaceholder;
    usePaddingLeft?: boolean;
    isHeaderInput?: boolean;
};

export const TextInputContainer: FunctionComponent<TextInputContainerProps> = ({
    children,
    paddingTop,
    usePaddingLeft,
    isHeaderInput,
}) => {
    const className = classnames(styles.textInputWrapper, {
        [styles.animatedPlaceholderPadding]: paddingTop === SIZES.animatedPlaceholder,
        [styles.usePaddingLeft]: usePaddingLeft,
        [styles.headerInput]: isHeaderInput,
    });

    return <div className={className}>{children}</div>;
};
